import styled, { css } from 'styled-components/native';
import { themes } from '../../design/colors';

interface ButtonProps {
  background?: string;
  color?: string;
  disabled?: boolean;
}

export const Container = styled.TouchableOpacity<ButtonProps>`
  justify-content: center;
  align-items: center;
  flex-direction: row;
  border-radius: 12px;
  height: 48px;
  background-color: ${(props) =>
    !!props.background
    ? props.background
    : props.disabled
    ? themes.colors.gray1
    : themes.colors.primary
  };
  margin-bottom: 16px;
`;

export const Title = styled.Text<ButtonProps>`
  color: ${(props) => !!props.color ? props.color : themes.colors.white};
  font-weight: 700;
`;
